import { Component, ChangeDetectionStrategy } from "@angular/core";
import { GridBaseComponent } from "../grid-base/grid-base.component";
import { CheckboxComponent } from "../../../checkbox/checkbox.component";
import { FormsModule } from "@angular/forms";

@Component({
    selector: "rask-grid-checkbox",
    templateUrl: "./grid-checkbox.component.html",
    styleUrls: ["../grid-base/grid-base.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CheckboxComponent,
        FormsModule
    ]
})
export class GridCheckboxComponent extends GridBaseComponent {
}
